/*global renderRecaptcha*/
window.onloadCallback = function () {
	renderRecaptcha();
}

export function rerunGravityFormsScripts()
{
	//Only find scripts inside the app-container as they are within Swup
	let selector = $('.body-wrapper').find('.gform_wrapper');

	if(selector.length > 0)
	{
		setTimeout(function () {
			let recaptcha_wrap = $('.ginput_recaptcha');
			let recaptcha_iframe = recaptcha_wrap.find('iframe');
			let og_script = 'https://www.google.com/recaptcha/api.js?hl=en&render=explicit&ver=5.2.2';
			let new_script = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&hl=en&render=explicit&ver=5.2.2';

			if (recaptcha_iframe.length <= 0 && recaptcha_wrap.length > 0) {
				if ($('script[src="' + og_script + '"]').length <= 0 || $('script[src="' + new_script + '"]').length <= 0) {
					$('body').append('<script type="text/javascript" src="' + new_script + '"></script>');
				}

				$(document).on('gform_post_render', function () {
					renderRecaptcha();
				});

			}
		
			// hacky forced property to ensure the actual form is rendered
			selector.css('display', 'block');

		}, 250);

		selector.each(function(){
			let scripts = $(this).parent().find('script');
			scripts.each(function(){
				let text = $(this).text();
				eval(text);
			});
		});
	}
}


export function copyProductInfo()
{
	const copyTrigger = document.querySelector('.copy-product-info__trigger');

	if(!copyTrigger)
	{
		return;
	}

	copyTrigger.addEventListener('click', function()
	{
		const parent = copyTrigger.parentNode;
		const textElement = parent.querySelector('.copy-product-info__text');

		let input =document.createElement('input');
		document.body.appendChild(input)
		console.log(textElement)
		input.value = textElement.innerText
		input.select();
		document.execCommand('copy',false);
		input.remove();
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/forms.js